import { useEffect, useState } from 'react';
import invariant from 'tiny-invariant';

const useMatchMedia = (mediaQueryString, initialState = true) => {
  invariant(typeof mediaQueryString === 'string', 'Expected `mediaQueryString` to be a string');
  invariant(typeof initialState === 'boolean', 'Expected `initialState` to be a boolean');

  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia(mediaQueryString);

      const updateState = () => {
        setState(mediaQueryList.matches);
      };
      updateState();

      mediaQueryList.addEventListener('change', updateState);
      return () => {
        mediaQueryList.removeEventListener('change', updateState);
      };
    }
  }, [mediaQueryString]);

  return state;
};

export default useMatchMedia;
